import { ErrorType } from '../../../../models/HttpError';
import { AppState } from '../../../../redux/reducers';
import { IdentifierTypeViewModel } from '../../../../models/Entities/Person/IdentifierType/IdentifierTypeModels';

// store
import * as IdentifierTypesStore from '../../../../redux/middleware/PersonIdentifierTypes.Middleware';

export interface IProps {
  selectedIdentifierTypeId?: number | undefined;
  label?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  errorMessage?: string | undefined;
  // when informed, only the identifier types available for that kind of person are offered
  personType?: number | undefined;
  onSelectionChange: (identifierTypeId: number | undefined) => void;
}

interface ConnectedProps {
  isLoading: boolean | undefined;
  isLoadingSuccessfully: boolean | undefined;
  error: ErrorType | undefined;
  identifierTypes: IdentifierTypeViewModel[];
}

interface DispatchProps {
  GetIdentifierTypes: typeof IdentifierTypesStore.actionCreators.GetIdentifierTypes;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.PersonIdentifierTypes?.isLoadingAll,
  isLoadingSuccessfully: state.PersonIdentifierTypes?.successLoadingAll,
  error: state.PersonIdentifierTypes?.error,
  identifierTypes: (state.PersonIdentifierTypes?.list ?? [])
    .filter((item: IdentifierTypeViewModel) => item.isActive && !item.isDeleted)
    .sort((a: IdentifierTypeViewModel, b: IdentifierTypeViewModel) =>
      (a.name || '').localeCompare(b.name || '')
    ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...IdentifierTypesStore.actionCreators
};
